import { StyledContent as TauronHeightContainer } from './styles';

export default TauronHeightContainer;
